import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../style/body-style.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CK_en from '../resources/CK_en.json';
import CK_fr from '../resources/CK_fr.json';
import LanguageContext from '../components/LanguageContext';

function RequestSubmitted() {
  const location = useLocation();
  const navigate = useNavigate();
  const { record, searchRecord, formData, serverStatusCode} = location.state || {};

  const { language } = useContext(LanguageContext);
  const CK = language === 'en' ? CK_en : CK_fr;
  document.title = CK['retrieve_key.title'];


  // Clear sessionStorage when this component mounts
  useEffect(() => {
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    const unblock = window.history.pushState(null, '', window.location.pathname);
    const onPopState = () => {
      navigate('/', { replace: true });
    };
    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  },[navigate]);

  const showEmailOrPostalCode = (formData) => {
    let statusDescription = 'Your company key request is under review';
    if (serverStatusCode && serverStatusCode.includes('CK_API_BIZ_I30001')) {
      statusDescription = CK["retrieve_key.whats_next.email"] + formData.officialEmail;
    } else if (serverStatusCode && serverStatusCode.includes('CK_API_BIZ_I30002')) {
      statusDescription = CK["retrieve_key.whats_next.mailout." + record.register];
    } else if (serverStatusCode && serverStatusCode.includes('CK_API_BIZ_I30003')) {
      statusDescription = CK["retrieve_key.whats_next.use_questions"] + " " + formData.email + CK["retrieve_key.whats_next.use_questions_after"];
    }
    return <> {statusDescription} </>;
  };

  console.log(record)
  console.log(record.register)

  const handleRegistry = () => {
    if (record.register === 'onbis-partnerships') {
      return [CK["get_entity.label.identifier.onbis-partnerships"], record.entityIdentifier];
    } else if (record.register === 'onbis-businessnames') {
      return [CK["get_entity.label.identifier.onbis-businessnames"], record.entityIdentifier];
    } else if (record.register === 'onbis-corporations') {
      return [CK["get_entity.label.identifier.onbis-corporations"], record.entityIdentifier];
    }
  };

  const handleStartOver = () => {
    navigate('/');
  };

  if (!record || !formData) {
    return <div>No Information</div>;
  }

  return (
    <div className="main-content">
      <Header />
      <div className="retrieve-key__container">
        <div className="ontario-row">
        <div className="ontario-alert ontario-alert--success" role="alert" tabIndex="0">
          <div className="ontario-alert__header">
            <div className="ontario-alert__header-icon" aria-hidden="true">
              <svg className="svg-icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="36" height="36">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.4-1.4 3.6 3.58L17.17 7l1.4 1.42L10 17z" fill="#118847"/>
                <path d="M5 12l5 5 8.58-8.58L17.17 7 10 14.17 6.4 10.6 5 12z" fill="#fff"/>
              </svg>
            </div>
            <h2 className="ontario-alert__header-title ontario-h4">
              {CK["retrieve_key.header"]}
            </h2>
          </div>
          <div className="ontario-alert__body">
            <div className="ontario-row get-entity__entity-info">
              <div className="get-entity__entity-info__col1">{CK["retrieve_key.corporation_name"]}</div>
              <div className="get-entity__entity-info__col2">{record.entityName}</div>
            </div>
            <div className="ontario-row get-entity__entity-info">
              <div className="get-entity__entity-info__col1">
                {handleRegistry() ? handleRegistry()[0] : null}
              </div>
              <div className="get-entity__entity-info__col2">
                {handleRegistry() ? handleRegistry()[1] : null}
              </div>
            </div>
            <div className="ontario-row get-entity__entity-info">
              <div className="get-entity__entity-info__col1">{CK["retrieve_key.address.onbis-corporations"]}</div>
              <div className="get-entity__entity-info__col2">{searchRecord.registeredHeadOfficeAddress}</div>
            </div>
          </div>
        </div>
        </div>
        <br />
        <span className="ontario-row ontario-h2">
          <span 
            className="ontario-label ontario-label--heading"
            tabIndex="0"
            style={{ margin: '0 0 1rem 0' }}
          >
            {CK["retrieve_key.whats_next"]}
          </span>
        </span>
        <div className="ontario-row">
          <p tabIndex="0">
            {showEmailOrPostalCode(formData)}
          </p>
        </div>
        <div className="ontario-row">
          <button
            id="start-over"
            className="ontario-button ontario-button--primary"
            title={CK["footer.back1"]}
            onClick={handleStartOver}
            style={{ margin: '1rem 0 6rem 0' }}
          >
            {CK["retrieve_key.start_over"]}
          </button>
        </div>
      </div>
      <div>
    </div>

    {/* <hr className='ontario-row' />  */}

    <div className="ontario-row">
      <div id="rate-us" >
        <div className="feedback">
          <div className="ontario-alert-success-icon" style={{ float: 'left' }}>
              <img
                src="assets/icons/png/ontario-icon-sentiment-4.png"
                className="ontario-icon"
                alt="Success Icon"
                style={{
                  width: '40px',
                  height: '40px',
                  objectFit: 'contain',
                }} />      

              </div>
          <div className="ontario-alert-success-icon" style={{ justifyContent: 'center'}}>
            <span tabIndex="0">
              {CK["footer.rate_us.title3"]}&nbsp;
              {console.log(window.location.hostname)}
              <a
                href={
                  window.location.hostname === 'www.appmybizaccount.gov.on.ca'
                  //this has been changed but hasn't been finalized yet by Nasrin to check in Git.
                    ? (language === 'en'
                        ? 'https://survey.alchemer.com/s3/7970422/ROS-Ontario-Business-Registry-e?sts=100&acct=ONtx&svc=CKey&src=other'
                        : 'https://survey.alchemer.com/s3/7970576/ROS-Ontario-Business-Registry-f?sts=100&acct=ONtx&svc=CKey&src=other')
                    : (language === 'en'
                        // ? 'https://survey.alchemer.com/s3/7970422/ROS-Ontario-Business-Registry-e?sts=100&acct=ONtx&svc=CKey&src=other'
                        // : 'https://survey.alchemer.com/s3/7970576/ROS-Ontario-Business-Registry-f?sts=100&acct=ONtx&svc=CKey&src=other')
                        ? 'https://survey.alchemer.com/s3/6406791/Ontario-Business-Registry-e-UAT?sts=100&acct=ONtx&svc=CKey&src=other'                        
                        : 'https://survey.alchemer.com/s3/6406828/Ontario-Business-Registry-f-UAT?sts=100&acct=ONtx&svc=CKey&src=other')
                }
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0066cc', display: language === 'en' ? 'inline' : 'flex' }}
              >
                {CK["footer.rate_us.title4"]}
              </a>
            </span>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}

export default RequestSubmitted;
